import { memo as Memo, useRef, useCallback } from 'react';

//* GSAP
import gsap from 'gsap';

//* Components
import Text from 'components/common/Text';
import EventHeroItem from './EventHeroItem';
import Container from 'components/common/Container';

//* Style
import EventHeroStyle from './style';

const EventHero = Memo(({ data, className }) => {
	//! Refs
	const cursorRef = useRef();
	const eventHeroContRef = useRef();

	//! Handle mouse move
	const handleMouseMove = useCallback((e) => {
		const eventHeroContRect = eventHeroContRef.current.getBoundingClientRect();

		const x = e.clientX - eventHeroContRect.left;
		const y = e.clientY - eventHeroContRect.top;

		gsap.to(cursorRef.current, { duration: 0.3, opacity: 1, left: x, top: y, scale: 1 });
	}, []);

	//! Handle mouse leave
	const handleMouseLeave = useCallback(() => {
		gsap.to(cursorRef.current, { duration: 0.3, opacity: 0, scale: 0 });
	}, []);

	return (
		<EventHeroStyle className={`${className || ''}`}>
			<Container>
				{data.map((item, index) => (
					<div
						key={index}
						ref={eventHeroContRef}
						onMouseMove={handleMouseMove}
						onMouseLeave={handleMouseLeave}
						className={`event-hero-item-wrap`}>
						<EventHeroItem
							time={item.time}
							slug={item.slug}
							date={item.date}
							place={item.place}
							title={item.title}
							text={item.featured_text}
							image={item.featured_image}
						/>

						<div
							ref={cursorRef}
							className={`event-drag-container`}>
							<Text
								tag={`span`}
								className={`event-drag notoSans-medium uppercase p p3`}
								text={`seeDetails`}
							/>
						</div>
					</div>
				))}
			</Container>
		</EventHeroStyle>
	);
});

export default EventHero;
